import { ZodSchema } from 'zod';

export const validateData = <T>(schema: ZodSchema<T>, data: unknown): { success: boolean; data?: T; errors?: Record<string, string> } => {
  const result = schema.safeParse(data);
  
  if (result.success) {
    return { success: true, data: result.data };
  }
  
  const errors: Record<string, string> = {};
  result.error.errors.forEach((err) => {
    const path = err.path.join('.');
    errors[path] = err.message;
  });
  
  return { success: false, errors };
};
